import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useFormContext } from 'react-hook-form';

import { goToPage } from '@epi-actions/navigation';
import { routerPaths } from '@epi-constants/routerPaths';
import { toComma } from '@epi-helpers/commaHelper';

import EstimationDetails from './EstimationDetails';
import {
  companyAccountApi,
  useGetTransferMoneyEstimationQuery
} from '@epi-api/companyAccount';
import { TransferMoneyFormFields } from '@epi-pages/TransferPage/LoadCompanyAccount/helpers';

function TransferUnfulfilledRequestSummary() {
  const { setValue } = useFormContext();
  const { data: estimation } = useGetTransferMoneyEstimationQuery();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(companyAccountApi.util.resetApiState());
    };
  }, []);

  if (!estimation) {
    return null;
  }

  const setSuggestedTransferAmount = (amountValue: number) =>
    setValue(TransferMoneyFormFields.Amount, toComma(amountValue.toFixed(2)));

  const navigateToRequestedLoadsPage = () =>
    dispatch(goToPage(routerPaths.requestedLoads));

  return (
    <EstimationDetails
      estimation={estimation}
      setSuggestedTranserAmount={setSuggestedTransferAmount}
      navigateToRequestedLoadsPage={navigateToRequestedLoadsPage}
    />
  );
}

export default TransferUnfulfilledRequestSummary;
